import React from 'react'

interface Props {
  onZoomIn: () => void
  onZoomOut: () => void
  onReset: () => void
}

export function ZoomControls({ onZoomIn, onZoomOut, onReset }: Props) {
  return (
    <div style={{ position: 'absolute', top: 10, right: 10, display: 'flex', gap: 6, zIndex: 5 }}>
      <button className="chip" style={{ fontSize: 10, padding: '3px 8px' }} onClick={onZoomIn}>＋</button>
      <button className="chip" style={{ fontSize: 10, padding: '3px 8px' }} onClick={onZoomOut}>－</button>
      <button className="chip" style={{ fontSize: 10, padding: '3px 8px' }} onClick={onReset}>Reset</button>
    </div>
  )
}
